import { BusinessAreas } from './business-areas'

export { BusinessAreas }